import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const PARENTESCOS = ["Pai", "Mãe", "Esposo(a)", "Irmão(ã)", "Outro"];
export const digitos = (s) => (s || "").replace(/\D/g, "");
export const maskTel = (v) => {
  const d = digitos(v).slice(0, 11);
  if (d.length <= 2) return d;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};
export const telValido = (v) => { const d = digitos(v); return (d.length === 10 || d.length === 11) && d[0] !== "0" && new Set(d).size > 2; };
export const VAZIO = () => ({ nome: "", telefone: "", parentesco: "", vinculo: "" });

/** Pendências de formato dos contatos (mesma regra do servidor). obrigatorio=false valida só preenchidos. */
export function pendenciasContatos(contatos, telefonePrincipal, obrigatorio = true) {
  const cs = (contatos || []).slice(0, 2);
  const p = [];
  cs.forEach((c, i) => {
    const vazio = !c.nome && !c.telefone && !c.parentesco;
    if (!obrigatorio && vazio) return;
    if (!c.nome?.trim()) p.push(`Contato ${i + 1}: nome`);
    if (!telValido(c.telefone)) p.push(`Contato ${i + 1}: telefone com DDD`);
    if (!c.parentesco) p.push(`Contato ${i + 1}: parentesco`);
    else if (c.parentesco === "Outro" && !c.vinculo?.trim()) p.push(`Contato ${i + 1}: informe o vínculo`);
  });
  if (obrigatorio && cs.length < 2) p.push("São necessários 2 contatos familiares");
  const t = cs.map((c) => digitos(c.telefone)).filter(Boolean);
  if (t.length === 2 && t[0] === t[1]) p.push("Os dois contatos não podem ter o mesmo telefone");
  const tp = digitos(telefonePrincipal);
  if (tp && t.includes(tp)) p.push("Telefone do contato igual ao telefone principal");
  return p;
}

export function ContatosFamiliares({ value, onChange, telefonePrincipal, obrigatorio = true, testid = "contato", mostrarErros = false }) {
  const cs = [value?.[0] || VAZIO(), value?.[1] || VAZIO()];
  const upd = (i, k, v) => { const n = cs.map((c) => ({ ...c })); n[i][k] = k === "telefone" ? maskTel(v) : v; if (k === "parentesco" && v !== "Outro") n[i].vinculo = ""; onChange(n); };
  const pend = mostrarErros ? pendenciasContatos(cs, telefonePrincipal, obrigatorio) : [];
  return (
    <div className="space-y-4" data-testid={`${testid}s`}>
      {cs.map((c, i) => (
        <div key={i} className="rounded-xl border p-3 space-y-2" data-testid={`${testid}-${i + 1}`}>
          <p className="text-sm font-semibold">Contato familiar {i + 1}{obrigatorio && <span className="text-red-500"> *</span>}{c.legado && <span className="ml-2 text-[11px] font-normal text-slate-500">(migrado das referências — confira)</span>}</p>
          <div className="grid sm:grid-cols-3 gap-2">
            <div><Label className="text-xs">Nome</Label><Input value={c.nome} onChange={(e) => upd(i, "nome", e.target.value)} data-testid={`${testid}-${i + 1}-nome`} className="mt-1" /></div>
            <div><Label className="text-xs">Telefone com DDD</Label><Input inputMode="numeric" value={c.telefone} onChange={(e) => upd(i, "telefone", e.target.value)} placeholder="(00) 00000-0000" data-testid={`${testid}-${i + 1}-telefone`} className="mt-1" /></div>
            <div><Label className="text-xs">Parentesco</Label>
              <Select value={c.parentesco || "none"} onValueChange={(v) => upd(i, "parentesco", v === "none" ? "" : v)}>
                <SelectTrigger data-testid={`${testid}-${i + 1}-parentesco`} className="mt-1"><SelectValue placeholder="Selecione" /></SelectTrigger>
                <SelectContent><SelectItem value="none">Selecione</SelectItem>{PARENTESCOS.map((p) => <SelectItem key={p} value={p}>{p}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            {c.parentesco === "Outro" && <div className="sm:col-span-3"><Label className="text-xs">Qual o vínculo? *</Label><Input value={c.vinculo || ""} onChange={(e) => upd(i, "vinculo", e.target.value)} placeholder="Ex.: tio, amigo, vizinho" data-testid={`${testid}-${i + 1}-vinculo`} className="mt-1" /></div>}
          </div>
        </div>
      ))}
      {pend.length > 0 && <ul className="text-xs text-red-600 list-disc pl-4" data-testid={`${testid}s-pendencias`}>{pend.map((x) => <li key={x}>{x}</li>)}</ul>}
      <p className="text-[11px] text-slate-500">A validação confere apenas o formato do número; não confirma titularidade nem se o número está ativo.</p>
    </div>
  );
}
